<div> 
    <p>{{data.name}}</p>
</div>

<div style="display: flex;justify-content: center;">
    <button class="save btn" (click)="save(1)" style="width: fit-content;">Okay</button>
</div>